import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

class Feature extends Component {
	render() {
		return (
			<div>
				<section className="section is-fullheight has-text-centered" id="feature" name="scroll-to-feature">
					<div className="container feature">
						<div className="content is-centered">
							<Fade left cascade>
								<h2 className="title is-uppercase">Our Feature</h2>
								<p className="subtitle">Beberapa Fitur yang kami miliki</p>
							</Fade>
						</div>
						<div className="columns is-flex is-multiline is-centered">
							<div className="column is-narrow-mobile">
								<Fade left cascade>
									<div className="card">
										<div className="card-image is-flex is-horizontal-center">
											<figure className="image">
												<img src="/img/de-express-icon-clr.svg" alt="" />
											</figure>
										</div>
										<div className="card-content">
											<div className="content">
												<h4>De Ride</h4>
												<p>Lorem ipsum dolor sit amet.</p>
											</div>
										</div>
									</div>
								</Fade>
							</div>
							<div className="column is-narrow-mobile">
								<Fade left cascade>
									<div className=" card ">
										<div className="card-image is-flex is-horizontal-center">
											<figure className="image">
												<img src="/img/de-food-icon-clr.svg" alt="" />
											</figure>
										</div>
										<div className="card-content">
											<div className="content">
												<h4>De Food</h4>
												<p>Lorem ipsum dolor sit amet.</p>
											</div>
										</div>
									</div>
								</Fade>
							</div>
							<div className="column is-narrow-mobile">
								<Fade left cascade>
									<div className=" card ">
										<div className="card-image is-flex is-horizontal-center">
											<figure className="image">
												<img src="/img/de-express-icon-clr.svg" alt="" />
											</figure>
										</div>
										<div className="card-content">
											<div className="content">
												<h4>De Express</h4>
												<p>Lorem ipsum dolor sit amet.</p>
											</div>
										</div>
									</div>
								</Fade>
							</div>
							<div className="column is-narrow-mobile">
								<Fade left cascade>
									<div className=" card ">
										<div className="card-image is-flex is-horizontal-center">
											<figure className="image">
												<img src="/img/de-shop-icon-clr.svg" alt="" />
											</figure>
										</div>
										<div className="card-content">
											<div className="content">
												<h4>De Shop</h4>
												<p>Lorem ipsum dolor sit amet.</p>
											</div>
										</div>
									</div>
								</Fade>
							</div>
						</div>
						<div className="columns is-centered is-flex is-multiline">
							<div className="column is-3 is-narrow-mobile">
								<Fade left cascade>
									<div className=" card ">
										<div className="card-image is-flex is-horizontal-center">
											<figure className="image">
												<img src="/img/de-rental-icon-clr.svg" alt="" />
											</figure>
										</div>
										<div className="card-content">
											<div className="content">
												<h4>De Rental</h4>
												<p>Lorem ipsum dolor sit amet.</p>
											</div>
										</div>
									</div>
								</Fade>
							</div>
							<div className="column is-3 is-narrow-mobile">
								<Fade left cascade>
									<div className=" card ">
										<div className="card-image is-flex is-horizontal-center">
											<figure className="image img-23">
												<img src="/img/de-payment-icon-clr.svg" alt="" />
											</figure>
										</div>
										<div className="card-content">
											<div className="content">
												<h4>De Saldo</h4>
												<p>Lorem ipsum dolor sit amet.</p>
											</div>
										</div>
									</div>
								</Fade>
							</div>
							<div className="column is-3 is-narrow-mobile">
								<Fade left cascade>
									<div className=" card ">
										<div className="card-image is-flex is-horizontal-center">
											<figure className="image">
												<img src="/img/de-medcare-icon-clr.svg" alt="" />
											</figure>
										</div>
										<div className="card-content">
											<div className="content">
												<h4>De Medcare</h4>
												<p>Lorem ipsum dolor sit amet.</p>
											</div>
										</div>
									</div>
								</Fade>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default Feature;
